import React from 'react';

import MyTISection from './Section';

const MyTIOrgCharts = () => {
  return (
    <MyTISection
      highlight="Label"
      subtitle="Lorem ipsum dolor sit amet consectetur adipisicing elit"
      title="Org Charts"
    >
      <div>Org Charts</div>
    </MyTISection>
  );
};

export default MyTIOrgCharts;
